module.exports = __webpack_public_path__ + "static/media/Poster_L2.3937b83a.svg";